/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserPrebidAlertSuppression {
  None = 'none',
  ThisAuction = 'this_auction',
  UntilNextPrebid = 'until_next_prebid',
  Forever = 'forever'
}
